import { render } from "./HomeLinkComponent.vue?vue&type=template&id=186d4b7c"
import script from "./HomeLinkComponent.vue?vue&type=script&lang=js"
export * from "./HomeLinkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__